import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress the benign "ResizeObserver loop completed with undelivered
// notifications" error that react-pdf can emit while rendering pages —
// it surfaces in the CRA dev error overlay and can cover the preview UI.
const _roMsg = "ResizeObserver loop";
window.addEventListener("error", (e) => {
  if (e.message && e.message.includes(_roMsg)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
// NOTE: React.StrictMode intentionally NOT used. Its dev-only double
// mount/unmount tears down react-pdf's PDF worker while page getPage()
// calls are still in flight, throwing "Cannot read properties of null
// (reading 'sendWithPromise')" and crashing the signing designer. This has
// no effect on production behaviour (StrictMode is a dev-only tool).
root.render(<App />);
